<template><div></div></template>

<script>
export default {};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.section {
  display: flex;
  flex-direction: row;
  //   min-height: 100px;
  //   width: 400px;
  justify-content: flex-start;

  align-content: center;
  height: 50px;
  padding-left: 15px;

  a {
    color: $point1;
  }
}
</style>